import { api } from '../../lib/api';
import type { GuestAuthResponse, GuestProfile, OtpRequestResponse } from '@pms/shared';

export async function requestOtp(email: string): Promise<OtpRequestResponse> {
  const { data } = await api.post<OtpRequestResponse>('/auth/otp/request', { email });
  return data;
}

export async function verifyOtp(email: string, code: string): Promise<GuestAuthResponse> {
  const { data } = await api.post<GuestAuthResponse>('/auth/otp/verify', { email, code });
  return data;
}

export async function getMe(): Promise<GuestProfile> {
  const { data } = await api.get<GuestProfile>('/auth/me');
  return data;
}

export async function refreshTokens(refreshToken: string): Promise<GuestAuthResponse> {
  const { data } = await api.post<GuestAuthResponse>('/auth/refresh', { refreshToken });
  return data;
}

export async function logoutRequest(refreshToken: string): Promise<void> {
  await api.post('/auth/logout', { refreshToken });
}
